<template>
  <div class="movie-hovering-card">
    <div class="movie-hovering-card__img-shadow"></div>
    <div class="movie-hovering-card__body">
      <div class="buttons-icon">
        <button
          v-if="device.isDesctop"
          class="btn__inline-icon"
          @click="handleToMoviePlay(item)">
          <i class="icon-play-line"></i>
        </button>
        <button
          v-if="!props.isAddedWatchlist"
          class="btn__inline-icon"
          @click="addDeleteWatchlist('add')">
          <i class="icon-heart-inline"></i>
        </button>
        <button
          v-else
          class="btn__inline-icon"
          @click="addDeleteWatchlist('delete')">
          <font-awesome-icon :icon="['far', 'fa-heart']" />
        </button>
        <button
          class="btn__inline-icon"
          @click="handleToMovie(item)">
          <i class="icon-info-circle"></i>
        </button>
      </div>
      <div class="movie-title">{{ item?.title[lang] || item?.title }}</div>
      <div class="movie-data">
        <div
          v-if="item?.mediaItems && item?.mediaItems[0]?.length"
          class="movie-data__time">
          {{ Math.floor(item?.mediaItems[0]?.length / 3600) }}h
          {{ Math.floor((item?.mediaItems[0]?.length % 3600) / 60) }}m
        </div>
        <div class="movie-data__list">
          <span v-if="item?.years">{{ item?.years }}</span>
          <!-- <span>hd</span>
          <span>cc</span> -->
          <span v-if="item?.age_rating">{{ item?.age_rating }}</span>
        </div>
        <div
          v-if="movieWatchingData.length"
          class="movie-data__time-left">
          {{ ((movieWatchingData[1]?.duration - movieWatchingData[1]?.position) /
            60).toFixed(0) }} min left
        </div>
      </div>
      <div
        v-if="movieWatchingData.length"
        class="movie-progres">
        <div class="movie-progres__line"
          :style="{ width: ((movieWatchingData[1]?.position * 100) / movieWatchingData[1]?.duration).toFixed(0) + '%' }">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toast-notification';
import { useI18n } from 'vue-i18n';
import useMovieActiveWatching from '@/utils/useMovieActiveWatching';
import { i18nRoute } from '@/utils/useTranslate';


const store = useStore()
const router = useRouter()
const device = computed(() => store.state.device)
const lang = computed(() => store.state.language)
const isAuth = computed(() => store.state.auth.userData.isAuth)
const $toast = useToast();
const { t } = useI18n()

const props = defineProps({
  item: {
    type: Object,
    requared: true
  },
  watching: {
    type: Object,
  }
})

const asArray = Object.entries(props.watching);
const watchingListFiltered = asArray.filter(([key, value]) => {
  if (value.contentID === props.item.id) {
    return [key, value]
  }
})
const movieWatchingData = isAuth.value ? useMovieActiveWatching(watchingListFiltered, props.item.id) : []
const handleToMovie = (item) => {
  router.push(i18nRoute({ name: 'movie page', params: { id: item.slug } }))
}
const handleToMoviePlay = (item) => {
  router.push(i18nRoute(
    {
      name: 'movie page',
      params: { id: item.slug },
      hash: '#play'
    }))
}

const addDeleteWatchlistError = computed(() => store.state.watchlist.watchlistData.addDeleteError)
const addDeleteWatchlist = async (argument) => {
  if (isAuth.value) {
    argument === 'add'
      ? await store.dispatch('watchlist/addWatchlist', props.item.id || props.item._id)
      : await store.dispatch('watchlist/deleteItemWatchlist', props.item.id || props.item._id)

    if (!addDeleteWatchlistError.value) {
      $toast.success(
        t(argument === 'add'
          ? 'moviePage.movieAddWatchlistSuccess'
          : 'moviePage.movieDeleteWatchlistSuccess'),
        {
          position: 'top-right',
          duration: 5000
        })
      store.dispatch('moviePage/loadMovieData', props.item.id || props.item._id)

    } else {
      $toast.error(
        t(argument === 'add'
          ? 'moviePage.movieAddWatchlistError'
          : 'moviePage.movieDeletWatchlistError'),
        {
          position: 'top-right',
          duration: 5000
        })
    }
  } else {
    store.commit('watchlist/SET_MODAL_WATCHLIST_VISIBLE', true)
  }
}
</script>

<style lang="scss" scoped>
.movie-hovering-card {
  box-shadow: 5px 10px 15px rgba(0, 0, 0, 0.44);
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;


  position: absolute;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;

  // .movie-hovering-card__img-shadow

  &__img-shadow {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
    height: 100%;
  }

  // .movie-hovering-card__body

  &__body {
    background-color: $card-img-bg;
    flex: 0 0 auto;
    min-height: rem(170);
    padding: rem(16);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  }
}

.buttons-icon {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: rem(6);
}

.btn {

  // .btn__inline-icon

  &__inline-icon {
    color: $primary-color;
    font-size: rem(30);
    padding: rem(5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.movie-title {
  font-weight: 600;
  font-size: rem(20);
  line-height: math.div(30, 20);
  text-align: left;
}

.movie-data {
  display: flex;
  align-items: center;
  justify-content: space-between;

  // .movie-data__time

  &__time {
    font-weight: 500;
    font-size: rem(14);
    line-height: math.div(21, 14);
  }

  // .movie-data__list

  &__list {
    color: #A8A8A8;
    font-weight: 600;
    font-size: rem(12);
    line-height: math.div(18, 12);
    text-transform: uppercase;

    span {
      padding-right: rem(10);

      &::after {
        content: '\2022';
        height: rem(5);
        width: rem(5);
        position: absolute;
        margin-left: rem(2);
      }

      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }

  // .movie-data__time-left

  &__time-left {
    font-size: rem(14);
    line-height: math.div(21, 14);
  }

}

.movie-progres {
  background-color: #767A7F;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: rem(6);
  width: 100%;
  // .movie-progres__line

  &__line {
    background-color: $primary-color;
    height: rem(6);
    border-radius: rem(10);
  }
}
</style>